import { useMessagingContext } from "../providers/MessagingProvider"

export const useUnreadCount = (): number | undefined => {
  const { totalUnreadCount } = useMessagingContext()

  return totalUnreadCount
}

export const useMainInboxChannelIds = (): string[] | undefined => {
  const { mainInboxChannelIds } = useMessagingContext()

  return mainInboxChannelIds || []
}

export const useMessageRequestChannelIds = (): string[] | undefined => {
  const { messageRequestsChannelIds } = useMessagingContext()

  return messageRequestsChannelIds || []
}
